<app-navigation
  class="coded-navbar pc-sidebar"
  [ngClass]="{
    'navbar-collapsed': navCollapsed,
    horizontal: currentLayout === 'horizontal',
    compact: currentLayout === 'compact',
    'mob-open': navCollapsedMob
  }"
  (NavCollapsedMob)="navMobClick()"
></app-navigation>
<app-nav-bar (NavCollapsedMob)="navMobClick()"></app-nav-bar>
<div class="pc-container">
  <div class="coded-wrapper">
    <div class="coded-content">
      <div class="coded-inner-content">
        <app-breadcrumb></app-breadcrumb>
        <div class="main-body">
          <div class="page-wrapper">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pc-menu-overlay" (click)="closeMenu()" (keydown)="handleKeyDown($event)" tabindex="0"></div>
</div>
<!-- "Ask Atlas" — mounted once here so it floats over every admin screen -->
<app-atlas-widget></app-atlas-widget>
<!-- <footer class="pc-footer">
  <div class="footer-wrapper container-fluid">
    <div class="row">
      <div class="col my-1">
        <p class="m-0">
          Copyright &copy;
          <a href="https://codedthemes.com" target="_blank">CodedThemes</a>
        </p>
      </div>
      <div class="col-auto my-1">
        <ul class="list-inline footer-link mb-0">
          <li class="list-inline-item"><a href="https://codedthemes.com/" target="_blank">Home</a></li>
          <li class="list-inline-item">
            <a href="https://codedthemes.com/privacy-policy/" target="_blank">Privacy Policy</a>
          </li>
          <li class="list-inline-item"><a href="https://codedthemes.support-hub.io/" target="_blank">Contact us</a></li>
        </ul>
      </div>
    </div>
  </div>
</footer> -->
<app-configuration></app-configuration>
